<template>
  <v-app-bar app clipped-left clipped-right color="white">
    <v-btn
      v-if="isEmployee"
      elevation="0"
      class="rounded-10 btn-primary"
      @click="setAdminDialog(true)"
    >
      <v-icon class="mr-2">mdi-cog-box</v-icon>
      Admin Console
    </v-btn>
    <v-spacer />
    <v-toolbar-title @click="navigateHome()">
      <v-img
        @click="navigateHome"
        contain
        width="200"
        style="cursor: pointer"
        :src="require('@/assets/nexus-analyzer-logo.png')"
      />
    </v-toolbar-title>
    <v-spacer />
    <v-btn elevation="0" class="rounded-10" @click="logOut">
      <v-icon class="mr-2"> mdi-logout </v-icon>
      Log out
    </v-btn>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  name: "AppBar",

  computed: {
    ...mapGetters(["isEmployee"])
  },

  methods: {
    ...mapActions(["setAdminDialog"]),

    navigateHome() {
      this.$router.push("/").catch(() => {})
    },

    logOut() {
      window.location = `/oauth2/logout/`
    }
  }
}
</script>
